import React from 'react'
import { constants } from 'common/helpers'

import composeDialogModal from 'components/modal/DialogModal/composeDialogModal'

import messages from './messages'


const ChangesSaveSuccessModal = composeDialogModal({
  name: constants.modals.ChangesSaveSuccess,
  contentMessage: messages.text,
})

export default ChangesSaveSuccessModal
